import { noop } from 'lodash';

export const onLoginSymbol = Symbol('On login callback');
export const onLogoutSymbol = Symbol('On logout callback');

const defaultAccessObject = {
  authType: null,
  idToken: null,
  accessToken: null,
  refreshToken: null,
  expiresAt: null,
};

export const normalizeAccessObject = (object = {}) => ({
  ...defaultAccessObject,
  ...object,
});

const defaultIdentity = {
  id: null,
  roles: [],
  isAdmin: undefined,
};

export const normalizeIdentity = (object = {}) => ({
  ...defaultIdentity,
  ...object,
});

export default class BridgeProvider {
  async init({ onLogin = noop, onLogout = noop }) {
    this[onLoginSymbol] = onLogin;
    this[onLogoutSymbol] = onLogout;

    return this;
  }

  async login() {
    return null;
  }

  async logout() {
    await this.clear();
    this[onLogoutSymbol]();

    return null;
  }

  async renew() {
    return null;
  }

  async clear() {
    return null;
  }

  getIdentity() {
    return null;
  }

  getAccessObject() {
    return {
      ...defaultAccessObject,
    };
  }

  getRequestHeaders() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/Auth/providers/BaseProvider.js